import { updateBuilderState } from 'common/builder/actions/updateBuilderState'
import { IBuilderState, FlowSimulatorState } from 'common/builder/builderInterfaces'
import * as builderStateSelectors from 'common/builder/selectors/builder/builderStateSelectors'
import { IThunkAction } from 'common/core/interfaces/actions'

import { getFlowSimulatorState, getSimulatorData } from '../selectors/flowSimulatorSelectors'

export const updateFlowSimulatorState = (
  builderId: string,
  changes: Partial<FlowSimulatorState>,
): IThunkAction => {
  return (dispatch, getState) => {
    const current: IBuilderState = builderStateSelectors.getById(getState(), builderId)

    const flowSimulator = { ...current.flowSimulator, ...changes }
    dispatch(
      updateBuilderState(builderId, {
        flowSimulator,
      }),
    )
  }
}

export const openFlowSimulator =
  (builderId: string): IThunkAction =>
  (dispatch, getState) => {
    const simulatorData = getSimulatorData(getState(), builderId)

    const simulatorDataString = JSON.stringify(simulatorData)

    dispatch(
      updateFlowSimulatorState(builderId, {
        open: true,
        simulatorData: simulatorDataString,
      }),
    )

    return simulatorDataString
  }
export const closeFlowSimulator = (builderId: string) => {
  return updateFlowSimulatorState(builderId, { open: false, simulatorData: null })
}

export const checkFlowSimulatorActual =
  (builderId: string): IThunkAction =>
  (dispatch, getState) => {
    const actualSimulatorData = JSON.stringify(getSimulatorData(getState(), builderId))
    const simulatorState = getFlowSimulatorState(getState(), builderId)

    return simulatorState.simulatorData === actualSimulatorData
  }
